<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M693.693-457.308H180.001v-45.384h513.692L448.385-747.999l31.615-32L779.999-480 480-180.001l-31.615-32 245.308-245.307Z"/></svg>
</template>
